import { render, staticRenderFns } from "./DialogServiceBilling.vue?vue&type=template&id=b2aa85c2&scoped=true&"
import script from "./DialogServiceBilling.vue?vue&type=script&lang=js&"
export * from "./DialogServiceBilling.vue?vue&type=script&lang=js&"
import style0 from "./DialogServiceBilling.vue?vue&type=style&index=0&id=b2aa85c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aa85c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VCard,VIcon,VSelect})
